export default __webpack_public_path__ + "static/media/token_hive.1f940709.svg";